/** Keep in sync with Config::FILTERS (without "all") and nginx filter slug list. */
export const GALLERY_FILTER_SLUGS = [
  'gif',
  'kitten',
  'orange',
  'black',
  'white',
  'sleep',
  'funny',
  'fluffy',
  'mono',
  'blur',
  'says',
  'meme',
  'breeds',
  'jpg',
  'cotd',
  'big',
  'small',
  'user',
  'liked',
] as const;

export function catUrl(name: string): string {
  return name === 'all' ? '/' : '/' + encodeURIComponent(name);
}

export function parseFilterFromPath(
  pathname: string,
  validFilters: Set<string> | string[],
): string {
  const slug = pathname.replace(/^\/+|\/+$/g, '');
  if (slug === '') {
    return 'all';
  }
  const valid = validFilters instanceof Set ? validFilters : new Set(validFilters);
  return valid.has(slug) ? slug : 'all';
}

export function parseFilterFromQuery(
  catParam: string | null,
  validFilters: Set<string> | string[],
): string {
  const valid = validFilters instanceof Set ? validFilters : new Set(validFilters);
  if (catParam && valid.has(catParam)) {
    return catParam;
  }
  return 'all';
}
